import { isPartMeasurePlaybackRule } from '../score/playbackRules';
import type { PartMeasurePlaybackRule } from '../score/types';

/** Keeps visit/staff semantics without duplicating the visible instructions. */
export const MUSICXML_PART_PLAYBACK_OTHER_PLAY_TYPE = 'scoreguard-part-playback';

export function parsePartPlaybackMarker(measure: Element): PartMeasurePlaybackRule[] | undefined {
  const value = Array.from(measure.getElementsByTagName('other-play')).find(
    (node) => node.getAttribute('type') === MUSICXML_PART_PLAYBACK_OTHER_PLAY_TYPE,
  )?.textContent;
  if (!value) return undefined;
  try {
    const rules: unknown = JSON.parse(value);
    if (!Array.isArray(rules) || !rules.every(isPartMeasurePlaybackRule)) return undefined;
    return rules.map(({ visits, staff, startOffset, endOffset, octaveShift, silent }) => ({
      ...(visits ? { visits: [...visits] } : {}),
      ...(staff !== undefined ? { staff } : {}),
      ...(startOffset !== undefined ? { startOffset: { ...startOffset } } : {}),
      ...(endOffset !== undefined ? { endOffset: { ...endOffset } } : {}),
      ...(octaveShift !== undefined ? { octaveShift } : {}),
      ...(silent !== undefined ? { silent } : {}),
    }));
  } catch {
    return undefined;
  }
}
